import { useEffect, useState } from 'react';

import { usePrevious } from '../utils/hooks/usePrevious';
import {
  CollectionRestaurantDetail,
  DeliveryRestaurantDetail,
  MenuReposnse,
} from '../weborder/Api';
import { MenuData } from '../weborder/Store';

interface UseMenu {
  data: MenuReposnse | null;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useMenu = (
  getMenuByUrl: (url: string) => void,
  menus: MenuData,
  restaurantDetail: CollectionRestaurantDetail | DeliveryRestaurantDetail, // Get from useRestaurantDetails hook
): UseMenu => {
  const menuUrl = restaurantDetail?.MenuUrl;
  const previousMenuUrl = usePrevious(menuUrl);

  const [data, setData] = useState<MenuReposnse>(() => {
    let initialState: MenuReposnse = null;
    if (menuUrl) {
      const menu = menus[menuUrl];
      if (menu?.status === 'success') {
        initialState = menu.data;
      }
    }
    return initialState;
  });
  const [isLoading, setIsLoading] = useState<boolean>(!data);
  const [isSuccess, setIsSuccess] = useState<boolean>(!!data);

  useEffect(() => {
    const isMenuNotLoaded = !isSuccess && menuUrl;
    const hasMenuUpdated = previousMenuUrl && previousMenuUrl !== menuUrl;
    if (isMenuNotLoaded || hasMenuUpdated) {
      setIsLoading(true);
      setIsSuccess(false);
      // * Redux state - flipdish.MenuData[menuUrl]
      // - set menu data indexed by menuUrl
      getMenuByUrl(menuUrl);
    }
  }, [menuUrl]);

  useEffect(() => {
    const menu = menus[menuUrl];
    if (menu?.status === 'success') {
      setData(menu.data);
      setIsLoading(false);
      setIsSuccess(true);
    }
  }, [menus[menuUrl]?.status, menuUrl]);

  return {
    data,
    isLoading,
    isSuccess,
  };
};
